export enum ReservationStatus {
    Confirm = 0,
    Cancel,
    Flown,
    UN,
    OnHold,
    Unknown
}